export var NIGHT_SWITCH_TRANSLATION_KEY = 'night-switch';